const SENSITIVE_AUTH_PATHS = new Set([
  "/login",
  "/forgot-password",
  "/reset-password",
  "/cadastro",
  "/nova-senha",
]);

export function redirectLegacyResetPasswordHash(browserLocation) {
  const hash = browserLocation?.hash || "";

  if (!/^#\/reset-password(?:\?[^#]*)?$/.test(hash)) {
    return false;
  }

  browserLocation.replace(`${browserLocation.origin}${hash.slice(1)}`);
  return true;
}

export function isSensitiveAuthRoute(route) {
  return SENSITIVE_AUTH_PATHS.has(route?.path);
}

export function sanitizeAnalyticsLocation(location) {
  const browserOrigin = typeof window !== "undefined" ? window.location?.origin : null;
  const url = new URL(location, browserOrigin || "https://www.zinnes.com.br");
  return `${url.origin}${url.pathname}`;
}

export function capturePasswordResetCredentials(route, browserHistory, browserLocation) {
  const token = typeof route?.query?.token === "string" ? route.query.token : "";
  const email = typeof route?.query?.email === "string" ? route.query.email : "";

  if (token || email) {
    browserHistory.replaceState(null, "", browserLocation.pathname || "/reset-password");
  }

  return { token, email };
}
